import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import {useIsDrawerMode} from '../../../../../../../util/Ares/customHooks';
import {getFooterConfig} from './footerConfig';
import FormNavigationButtonV2 from '../FormNavigationButtonV2';
import FormNavigationButtonBodyDetailView from '../FormNavigationButtonBodyDetailView';

export default function TaskViewFooter({
	document,
	engagementId,
	taskId,
	headerId,
	sectionId,
	formBodyId,
	knowledgeFormBodyId,
	setBodyDataLoaded,
	setIsLoading,
	isLoading,
	className,
	isBodyDetailView = false
}) {
	const isDrawerMode = useIsDrawerMode();

	const footerProps = {
		engagementId,
		taskId,
		headerId,
		sectionId,
		formBodyId,
		knowledgeFormBodyId,
		setBodyDataLoaded,
		setIsLoading,
		isLoading,
		isDrawerMode,
		document,
		className,
		documentId: document?.id
	};

	let footerRender;
	if (document) {
		footerRender = getFooterConfig(document.documentTypeId, footerProps);
	}

	return (
		<StyledTaskViewFooter
			className={`StyledAresViewFooter ${className ? ' ' + className : ''}
			${isLoading ? 'loadingVisible' : ''}`}
		>
			<section className="custom-footer-container">{footerRender}</section>
			<section className="navigation-buttons-container">
				{isBodyDetailView ? (
					<>
						<FormNavigationButtonBodyDetailView
							type="back"
							engagementId={engagementId}
							documentTypeId={document?.documentTypeId}
							variant="secondary"
							styleName="BackButton"
							isDrawerMode={isDrawerMode}
							knowledgeFormBodyId={knowledgeFormBodyId}
							formBodyId={formBodyId}
							setIsLoading={setIsLoading}
						/>
						<FormNavigationButtonBodyDetailView
							type="next"
							engagementId={engagementId}
							documentTypeId={document?.documentTypeId}
							styleName="NextButton"
							isDrawerMode={isDrawerMode}
							knowledgeFormBodyId={knowledgeFormBodyId}
							formBodyId={formBodyId}
							setIsLoading={setIsLoading}
						/>
					</>
				) : (
					<>
						<FormNavigationButtonV2
							variant={'secondary'}
							type={'back'}
							documentTypeId={document?.documentTypeId}
							engagementId={engagementId}
							taskId={taskId}
							documentId={document?.id}
							headerId={headerId}
							sectionId={sectionId}
							styleName={'BackButton'}
							isDrawerMode={isDrawerMode}
							setBodyDataLoaded={setBodyDataLoaded}
						/>
						<FormNavigationButtonV2
							variant={'primary-alt'}
							type={'next'}
							documentTypeId={document?.documentTypeId}
							engagementId={engagementId}
							taskId={taskId}
							documentId={document?.id}
							headerId={headerId}
							sectionId={sectionId}
							styleName={'NextButton'}
							isDrawerMode={isDrawerMode}
							setBodyDataLoaded={setBodyDataLoaded}
						/>
					</>
				)}
			</section>
		</StyledTaskViewFooter>
	);
}

TaskViewFooter.propTypes = {
	document: PropTypes.shape({
		id: PropTypes.string,
		documentTypeId: PropTypes.number
	}),
	engagementId: PropTypes.number,
	taskId: PropTypes.string,
	headerId: PropTypes.number,
	sectionId: PropTypes.number,
	formBodyId: PropTypes.number,
	knowledgeFormBodyId: PropTypes.number,
	setBodyDataLoaded: PropTypes.func,
	setIsLoading: PropTypes.func,
	className: PropTypes.string
};

const StyledTaskViewFooter = styled.section`
	&.bodyDetailsFooter {
		position: absolute;
		bottom: 0;
		border-top: var(--px-1) solid var(--neutrals-300);
		.navigation-buttons-container {
			position: relative;
			right: calc(var(--px-14) * -1);
		}
	}
	&.compareResponsesStyledAresViewFooter {
		position: absolute;
		bottom: 0;
		width: calc(100% - var(--px-60)) !important;
		background: var(--neutrals-00white) !important;
		border-top: var(--px-1) solid var(--neutrals-300);
	}
	.custom-footer-container {
		display: flex;
		justify-content: flex-start;
		max-width: 65rem;
		margin-right: var(--px-7);
	}
`;
